import React from 'react';
import { InputV2, LinkV2, Box, FormField } from '@withjoy/joykit';
import { useSharedRegistryTranslations } from '@apps/registry/SharedRegistry.i18n';
import type { TabItemProps } from '@shared/components/Tabs/Tabs';
import { Tabs } from '@shared/components/Tabs/Tabs';
import type { CashFundPaymentMethodSelectProps } from './components/CashFundPaymentMethodSelect';
import { CashFundPaymentMethodSelect } from './components/CashFundPaymentMethodSelect';
interface CashFundPaymentMethodProps extends CashFundPaymentMethodSelectProps {
  isCharityFund: boolean;
  isLinkToCharitySelected: boolean;
  donationMethodTabs: TabItemProps[];
  isEditDialog: boolean;
  getClickableLink: (link: string) => string;
}

export const CashFundPaymentMethodV2: React.FC<CashFundPaymentMethodProps> = props => {
  const { formik, isMobile, isCharityFund, isLinkToCharitySelected, donationMethodTabs, isEditDialog, getClickableLink } = props;
  const errors = formik.errors;
  const { getCashFundDialogTranslations } = useSharedRegistryTranslations();

  const { charityLinkLabel, testLinkText } = getCashFundDialogTranslations();

  if (isCharityFund) {
    return (
      <>
        <Box minWidth="340px">
          <Tabs
            items={donationMethodTabs}
            isMobile={isMobile}
          />
        </Box>
        {isLinkToCharitySelected ? (
          <Box
            marginTop={5}
            style={isEditDialog ? {} : { textAlign: 'center' }}
            width={isEditDialog ? '100%' : ['100%', null, '413px']}
          >
            <FormField
              label={charityLinkLabel}
              error={formik.touched.charityLink && errors.charityLink}
            >
              <InputV2
                {...formik.getFieldProps('charityLink')}
                tabIndex={0}
                placeholder="ourcharity.org/donate"
                style={{ textAlign: isEditDialog ? 'left' : 'center' }}
              />
              <LinkV2
                href={getClickableLink(formik.values.charityLink || '')}
                target="_blank"
                style={{
                  fontSize: '13px',
                  lineHeight: '20px',
                  opacity: formik.values.charityLink ? 1 : 0,
                  display: !!errors.charityLink && formik.touched.charityLink ? 'none' : 'block',
                }}
                tabIndex={0}
              >
                {testLinkText}
              </LinkV2>
            </FormField>
          </Box>
        ) : (
          <Box
            width="100%"
            marginTop={5}
          >
            <CashFundPaymentMethodSelect {...props} />
          </Box>
        )}
      </>
    );
  } else {
    if (isEditDialog) {
      return (
        <Box marginTop={5}>
          <CashFundPaymentMethodSelect {...props} />
        </Box>
      );
    } else {
      return (
        <>
          <CashFundPaymentMethodSelect {...props} />
        </>
      );
    }
  }
};
